import { render, staticRenderFns } from "./CardPropertyValueChange.vue?vue&type=template&id=1beff566&scoped=true&"
import script from "./CardPropertyValueChange.vue?vue&type=script&lang=js&"
export * from "./CardPropertyValueChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beff566",
  null
  
)

export default component.exports